import styled from '@emotion/styled';
import { UserIcon } from 'ui/components/elements/UserIcon/UserIcon';
import dayjs from 'dayjs';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0 10px;
    justify-content: ${(props: { isSelf: boolean }) => (props.isSelf ? 'flex-end' : 'flex-start')};
`;

const AgentNameContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: var(--font-large);
`;

const MessageWrapper = styled.div`
    display: flex;
    gap: 10px;
    align-items: flex-end;
    width: fit-content;
    ${(props: { isSelf: boolean }) => (!props.isSelf ? 'margin-left: 30px;' : 'margin-left: auto;')}
`;

const DateContainer = styled.div`
    font-size: var(--font-small);
    width: fit-content;
    white-space: nowrap;
    margin-bottom: 5px;
    margin-left: ${(props: { isSelf: boolean }) => (!props.isSelf ? '0px;' : 'auto;')};
`;

const MessageContainer = styled.div`
    max-width: 80%;
    ${(props: { isSelf: boolean }) =>
        !props.isSelf
            ? `
        margin-left: 30px;
        `
            : `
        margin-left: auto;
        margin-right: 30px;
         color: var(--white);
        `}
    background-color: ${(props: { isSelf: boolean }) => (props.isSelf ? 'var(--blue)' : '#F0F0F0')};
    border-radius: 6px;
    padding: 8px 12px;
    font-weight: 500;
    font-size: 14px;
    line-height: 25.2px;
    letter-spacing: 2%;
    box-shadow: 2px 2px 4px 0px #0000001a;
`;

type Props = {
    icon_image: string | null;
    name: string;
    isSelf: boolean;
    date: string;
    message: string;
};

export const Message: React.FC<Props> = ({ icon_image, name, isSelf, date, message }) => {
    return (
        <Wrapper isSelf={isSelf}>
            {!isSelf && (
                <AgentNameContainer>
                    <UserIcon size={30} src={icon_image} border />
                    <span>{name}</span>
                </AgentNameContainer>
            )}
            <MessageWrapper isSelf={isSelf}>
                {isSelf && (
                    <DateContainer isSelf={isSelf}>
                        <span>{dayjs(date).format('YYYY/MM/DD HH:mm')}</span>
                    </DateContainer>
                )}
                <MessageContainer isSelf={isSelf} style={{ whiteSpace: 'pre-wrap' }}>
                    {message}
                </MessageContainer>
                {!isSelf && (
                    <DateContainer isSelf={isSelf}>
                        <span>{dayjs(date).format('YYYY/MM/DD HH:mm')}</span>
                    </DateContainer>
                )}
            </MessageWrapper>
        </Wrapper>
    );
};
